import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
import { useState, useEffect } from "react";
import axios from "axios";
export default function ProductsSection() {
    const { t, i18n } = useTranslation();
    useScrollAnimation();

    const [dataProduct, setDataProduct] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const respons = await axios.get("https://laravel-api.alnujoud-jo.com/api/products");
                setDataProduct(respons.data.data)
            }
            catch (error) {
                console.error("Error When Fetch Data : ", error)
            }
        }
        fetchData();
    }, [])

    const getLocalizedText = (key) => {
        return i18n.language === 'ar' ? key.A : key.E;
    };

    const showData = dataProduct.slice(0, 3).map((el, index) =>
        <div key={index} className="w-100 w-[32%] rounded-[8px] shadow-md shadow-[#00000024]">
            <div className="w-[100%] h-[260px]">
                <img className="w-full h-full rounded-t-[8px]" src={el.image} alt={el.title} />
            </div>
            <div className="p-[20px] flex flex-col gap-[25px] justify-between">
                <div className="flex flex-col gap-[5px]">
                    <div className="text-[20px] text-[#017E89] font-bold">
                        {t(getLocalizedText({ A: el.name_ar, E: el.name_en }))}
                    </div>
                    <p className="text-[13px]">
                        {t(getLocalizedText({ A: el.details_ar, E: el.details_en }).length > 50
                            ? getLocalizedText({ A: el.details_ar, E: el.details_en }).substring(0, 100) + "..."
                            : getLocalizedText({ A: el.details_ar, E: el.details_en }))}
                    </p>
                </div>
                <Link to={`/productsDetails/${el.id}`}>
                    <span className="capitalize font-bold">{t("More Details")}</span>
                    <img className="h-auto" src={require("../../assets/icons/twoLines.svg").default} alt="" />
                </Link>
            </div>
        </div>
    )
    return (
        <section className="relative py-[40px]">
            <div className="flex flex-col items-center justify-center mx-auto w-fit">
                <div className="js-scroll fade-top w-[90px] h-[30px]">
                    <img className="w-[100%] h-[100%]" src={require("../../assets/icons/lineMainTitle.svg").default} alt="" />
                </div>
                <div className="js-scroll fade-btm text-[35px] font-bold uppercase text-[#017E89]">{t("Products")}</div>
                <span className="js-scroll fade-btm w-[50%] bg-[#017E89] h-[3px]"></span>
            </div>
            <div className="container flex flex-col gap-[15px] items-center py-[20px]">
                <div className="f-fol w-full flex gap-[10px] flex-wrap ">
                    {showData}
                </div>
                <Link className="js-scroll fade-btm bg-[#017E89] w-fit px-[30px] py-[7px] rounded-[4px] text-white font-bold capitalize" to={"/product"}>{t("Show More")}</Link>
            </div>
        </section>
    );
}